<template>
  <div class="layout">
    <div class="box">
      <div class="title">Information Form</div>
      <div class="info">
        <div class="row1">
          <div class="inp">
            <div class="icon">
              <img src="../../assets/img/icon1.png" />
            </div>
            <input
              type="text"
              v-model="flight_no"
              @blur="validateFlightNumber"
              placeholder="Flight Number"
            />
            <div class="error">{{ errors.flight_no }}</div>
          </div>

          <div class="inp">
            <div class="icon">
              <img src="../../assets/img/icon2.png" />
            </div>
            <DatePicker
              v-model="airport_time"
              type="date"
              placeholder="Select date"
              @on-change="validatePickupDate($event)"
              style="width: 100%"
            />
            <div class="error">{{ errors.airport_time }}</div>
          </div>
          <div class="inp">
            <div class="icon">
              <img src="../../assets/img/icon2.png" />
            </div>
            <TimePicker
              type="time"
              format="HH:mm:00"
              placeholder="Select time"
              @on-change="validatePickupuTime($event)"
              style="width: 100%"
            />
            <div class="error">{{ errors.airport_time }}</div>
          </div>
        </div>
        <div class="row1">
          <div class="inp">
            <div class="icon">
              <img src="../../assets/img/icon3.png" />
            </div>
            <input
              type="text"
              v-model="name"
              @blur="validatePassengerName"
              placeholder="Passenger Name"
            />
            <div class="error">{{ errors.name }}</div>
          </div>
          <div class="inp">
            <div class="icon">
              <img src="../../assets/img/icon4.png" />
            </div>
            <input
              v-model="mobile"
              @blur="validateContact"
              type="number"
              placeholder="mobile Number"
            />
            <div class="error">{{ errors.mobile }}</div>
          </div>
        </div>
        <div class="row1">
          <div class="inp2">
            <div class="icon">
              <img src="../../assets/img/icon5.png" />
            </div>
            <input
              v-model="user_num"
              @blur="validatePassengers"
              @input="user_num = Math.min(user_num, maxNum)"
              type="number"
              placeholder="Select the number of passengers"
            />
            <div class="error">{{ errors.user_num }}</div>
          </div>
          <div class="inp2">
            <div class="icon">
              <img src="../../assets/img/icon6.png" />
            </div>
            <input
              v-model="luggage_num"
              @blur="validateLuggage"
              type="number"
              @input="luggage_num = Math.min(luggage_num, maxNum)"
              placeholder="Select the number of luggage"
            />
            <div class="error">{{ errors.luggage_num }}</div>
          </div>
          <div class="inp2">
            <div class="icon">
              <img src="../../assets/img/icon7.png" />
            </div>
            <Select
              v-model="model"
              style="width: 100%"
              @on-change="validateCarId($event)"
            >
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <div class="error">{{ errors.car_id }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">Service Guarantee</div>
      <div class="info">
        <div class="test">
          <div class="gift">
            <div class="icon">
              <img src="../../assets/img/icon8.png" />
            </div>
            <div class="subtitle">Punctuality Guarantee</div>
            <div class="desc">Real-time flight monitoring</div>
          </div>
          <div class="gift">
            <div class="icon">
              <img src="../../assets/img/icon9.png" />
            </div>
            <div class="subtitle">Professional Drivers</div>
            <div class="desc">Certified and experienced</div>
          </div>
          <div class="gift">
            <div class="icon">
              <img src="../../assets/img/icon10.png" />
            </div>
            <div class="subtitle">24/7 Service</div>
            <div class="desc">Available anytime</div>
          </div>
          <div class="gift">
            <div class="icon">
              <img src="../../assets/img/icon11.png" />
            </div>
            <div class="subtitle">Safety First</div>
            <div class="desc">Regular vehicle maintenance</div>
          </div>
        </div>
      </div>
    </div>
    <div class="goto" @click="confirm">
      <div class="btn">Book Now</div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
import { urlRequest } from "../../common/common";
import { mounted } from "vue";
export default {
  data() {
    return {
      // 表单数据
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      time: "",
      day: "",
      month: "",
      year: "",
      flight_no: "",
      airport_time: "",
      name: "",
      mobile: "",
      user_num: "",
      luggage_num: "",
      car_id: "",
      baseFeed: "",
      extraFeed: "",
      order_no: "",
      car_type: "",
      maxNum: 0,
      // 错误提示
      errors: {
        flight_no: "",
        airport_time: "",
        name: "",
        mobile: "",
        user_num: "",
        luggage_num: "",
        car_id: "",
      },
      dateOptions: {
        disabledDate: (date) => {
          // 只保留日期部分（去除时间），将当前时间设为0点
          const today = new Date(new Date().setHours(0, 0, 0, 0));
          return date < today; // 仅禁用今天之前的日期
        },
      },
      cityList: [],
      model: "",
    };
  },
  methods: {
    // 验证方法
    validateFlightNumber() {
      const regex = /^[A-Za-z0-9]+$/; // 允许仅包含英文和数字
      if (!this.flight_no.trim()) {
        this.errors.flight_no = "Flight number cannot be empty";
      } else if (!regex.test(this.flight_no)) {
        this.errors.flight_no =
          "Flight number can only contain letters and numbers";
      } else {
        this.errors.flight_no = "";
      }
    },

    validatePickupDate(date) {
      if (date) {
        this.airport_time = date;
      }

      if (!this.airport_time) {
        this.errors.airport_time = "Please select the pick-up date";
      } else {
        this.errors.airport_time = "";
      }
    },
    validatePickupuTime(time) {
      console.log("time:" + time);

      if (time) {
        this.time = time;
      }
      if (!this.time) {
        this.errors.time = "Please select the time";
      } else {
        this.errors.time = "";
      }
    },
    validateCarId(e) {
      this.car_type = this.cityList[e - 1].user_num + "-seater";
      this.maxNum = this.cityList[e - 1].user_num;
    },
    validatePassengerName() {
      const regex = /^[\u4e00-\u9fa5a-zA-Z]{2,20}$/;
      if (!this.name.trim()) {
        this.errors.name = "Name cannot be empty";
      } else if (!regex.test(this.name)) {
        this.errors.name = "Please enter a valid name (2-20 characters)";
      } else {
        this.errors.name = "";
      }
    },

    validateContact() {
      const regex = /^1[3-9]\d{9}$/;
      if (!this.mobile.trim()) {
        this.errors.mobile = "Contact information cannot be empty";
      } else if (!regex.test(this.mobile)) {
        this.errors.mobile = "Please enter a valid mobile phone number";
      } else {
        this.errors.mobile = "";
      }
    },

    validatePassengers() {
      if (!this.user_num) {
        this.errors.user_num = "Please select the number of passengers";
      } else if (parseInt(this.user_num) < 1) {
        this.errors.user_num = "At least 1 passenger";
      } else if (parseInt(this.user_num) > this.maxNum) {
        this.errors.user_num = `Cannot exceed ${this.maxPassengers} passengers`;
      } else {
        this.errors.user_num = "";
      }
    },

    validateLuggage() {
      if (!this.luggage_num) {
        this.errors.luggage_num = "Please select the number of luggage";
      } else if (parseInt(this.luggage_num) < 0) {
        this.errors.luggage_num = "Quantity cannot be negative";
      } else if (parseInt(this.luggage_num) > this.maxNum) {
        this.errors.luggage_num = `Cannot exceed ${this.maxNum} luggage`;
      } else {
        this.errors.luggage_num = "";
      }
    },

    validateCarType() {
      if (!this.model) {
        this.errors.model = "Please select the vehicle model";
      } else {
        this.errors.model = "";
      }
    },

    confirm() {
      console.log("airport_time", this.airport_time + " " + this.time);

      // 提交前验证所有字段
      this.validateFlightNumber();
      this.validatePassengerName();
      this.validateContact();
      this.validatePassengers();
      this.validateLuggage();
      this.validateCarType();
      this.validatePickupDate();
      this.validatePickupuTime();
      // 检查是否有错误
      if (!Object.values(this.errors).some((msg) => msg)) {
        if (this.extraFeed === "") {
          this.extraFeed = 0;
        }
        this.baseFeed = this.cityList[this.model - 1].price;

        urlRequest({
          url: this.api.submitReservation,
          method: "post",
          data: {
            flight_no: this.flight_no,
            airport_time: this.airport_time + " " + this.time,
            name: this.name,
            mobile: this.mobile,
            user_num: this.user_num,
            luggage_num: this.luggage_num,
            car_id: this.model,
          },
        }).then((res) => {
          console.log("res: " + res.data);

          if (res.data.code === 200) {
            this.order_no = res.data.data.order_no;
            console.log("提交成功,订单号为：" + this.order_no);
            this.$router.push({
              path: "reservationComfirm",
              query: {
                baseFeed: this.baseFeed,
                extraFeed: this.extraFeed,
                order_no: this.order_no,
                car_type: this.car_type,
              },
            });
          }
        });
      }
    },
    getCarType() {
      urlRequest({
        url: this.api.getCarType,
        method: "get",
        data: {},
      }).then((res) => {
        if (res.data.code === 200) {
          res.data.data.forEach((item) => {
            this.cityList.push({
              value: item.id,
              label: item.user_num + "-seater   NZ$ " + item.price,
              price: item.price,
              user_num: item.user_num,
            });
          });
          // 假设选中的车型是第一个
          this.maxNum = this.cityList[0].user_num;
        }
      });
    },
  },
  mounted() {
    this.getCarType();
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "reservation.scss";
</style>
